/**
 * Datos de contacto de soporte / atención al cliente.
 * Fuente única de verdad — no volver a hardcodear el canal por pantalla.
 */

/**
 * Número de WhatsApp de soporte, en formato E.164 sin `+` — que es como lo
 * espera `wa.me`. Legible: +56 9 4389 8715.
 */
export const SOPORTE_WHATSAPP = '56943898715'

/**
 * Construye un enlace a WhatsApp con un mensaje inicial opcional.
 *
 * El mensaje llega escrito en el cuadro de texto pero SIN enviar: la persona
 * todavía puede corregirlo o completarlo antes de mandarlo. Por eso conviene
 * que sea una primera línea de conversación ("Hola, necesito ayuda con…") y no
 * un asunto de correo — este canal reemplazó al `mailto:` que había antes.
 *
 * Se usa `wa.me` y no `api.whatsapp.com` porque resuelve solo el destino: en el
 * teléfono abre la app instalada y en el escritorio cae a WhatsApp Web.
 */
export function whatsappSoporte(mensaje?: string): string {
  const base = `https://wa.me/${SOPORTE_WHATSAPP}`
  return mensaje ? `${base}?text=${encodeURIComponent(mensaje)}` : base
}
